import { PropsWithChildren, ReactElement } from "react"
import cn from "classnames"
import { MediaRight } from "trunx"

import { Box, Headline2, Img, Media, Text } from "ui-kit/components-branded/index"

export function IndicatorCard({
    title,
    value,
    iconProps,
}: {
    title: ReactElement | string
    value: ReactElement | string
    iconProps?: {
        src: string
        width: number
        height: number
    }
}) {
    return (
        <Box className="has-constant-small-gaps is-flex is-flex-direction-column is-justify-content-space-between m-0">
            <Media className="is-justify-content-space-between">
                {!iconProps && title}
                {iconProps && <div className="image flex-shrink-1">{title}</div>}
                {iconProps && (
                    <MediaRight>
                        <Img
                            src={iconProps.src}
                            width={iconProps.width}
                            height={iconProps.height}
                        />
                    </MediaRight>
                )}
            </Media>
            <div>{value}</div>
        </Box>
    )
}

function Title({
    children,
    className,
    isSecondary,
}: PropsWithChildren<{ className?: string; isSecondary?: boolean }>) {
    return (
        <Text
            isSecondary={isSecondary}
            className={cn("is-inline-block has-text-dark-60", className)}
        >
            {children}
        </Text>
    )
}

function ValueBig({ children, isDanger }: PropsWithChildren<{ isDanger?: boolean }>) {
    return (
        <Headline2 className={cn("is-inline-block mt-4", { "has-text-danger-lite": isDanger })}>
            {children}
        </Headline2>
    )
}

function ValueSmall({ children }: PropsWithChildren<unknown>) {
    return (
        <Text isAccent size="h3" className="is-inline-block mt-1">
            {children}
        </Text>
    )
}

IndicatorCard.Title = Title
IndicatorCard.ValueBig = ValueBig
IndicatorCard.ValueSmall = ValueSmall
